import React from "react";
import axios from "axios";
import APIURL from "../../../Main/apiurl";
import { json } from "react-router-dom";

const create_home_slider = async (slider) => {
  try {
    let data = new FormData();
    data.append("image", slider?.image[0]);
    data.append("title", slider?.title);
    data.append("description", slider?.description);
    data.append("button", slider?.button);
    data.append("status", slider?.status);

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/create-home-slider`,
      data,
      config
    );

    if (response?.data?.status_code == 401) {
      localStorage.clear();
      window.location.href = "/";
      return response?.data;
    } else {
      return response?.data;
    }
  } catch (error) {
    return error;
  }
};

const update_home_slider = async (slider) => {
  try {
    let data = new FormData();
    data.append("id", slider?.id);
    data.append("image", slider?.image[0]);
    data.append("title", slider?.title);
    data.append("description", slider?.description);
    data.append("button", slider?.button);
    data.append("status", slider?.status);

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/update-home-slider`,
      data,
      config
    );

    if (response?.data?.status_code == 401) {
      localStorage.clear();
      window.location.href = "/";
      return response?.data;
    } else {
      return response?.data;
    }
  } catch (error) {
    return error;
  }
};

const get_home_slider = async (slider) => {
  try {
    const data = {
      id: slider?.id,
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/get-home-slider`,
      data,
      config
    );

    if (response?.data?.status_code == 401) {
      localStorage.clear();
      window.location.href = "/";
      return response?.data;
    } else {
      return response?.data;
    }
  } catch (error) {
    return error;
  }
};

const get_all_home_sliders = async (slider) => {
  try {
    const data = {
      search: slider?.search,
      sort: slider?.sort,
      status: slider?.status,
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/get-all-home-sliders `,
      data,
      config
    );

    if (response?.data?.status_code == 401) {
      localStorage.clear();
      window.location.href = "/";
      return response?.data;
    } else {
      return response?.data;
    }
  } catch (error) {
    return error;
  }
};

export {
  create_home_slider,
  update_home_slider,
  get_home_slider,
  get_all_home_sliders,
};
